import { render } from "./LearningInfor.vue?vue&type=template&id=6a2b8669&ts=true"
import script from "./LearningInfor.vue?vue&type=script&lang=ts"
export * from "./LearningInfor.vue?vue&type=script&lang=ts"

import "./LearningInfor.vue?vue&type=style&index=0&id=6a2b8669&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__